import { Box } from "@mui/material";

/**
 * Componente para exibir o indicador de campo obrigatório (*)
 * Usado em labels de formulários para indicar campos required
 */
const RequiredIndicator = () => (
  <>
    {" "}
    <Box component="span" sx={{ color: "error.main", fontSize: "0.70rem" }}>
      *
    </Box>
  </>
);

export default RequiredIndicator;
